module.exports = __webpack_public_path__ + "static/media/Cookies-and-Tracking-Technologies_FR.1516e023.pdf";